var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiGetOneClientOfferDownload } from '../../../../../actions/ClientRfpActions';
import { wrapDispatch, wrapNotifyError } from '../../../../../helpers/action';
import { usePromiseDoingCallback } from '../../../../../helpers/use/useHook';
const useDownload = (rfp, offers, dispatch, unmountRef) => {
    const { id, name } = rfp;
    const rawOnClick = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const idList = offers.map((v) => v.id);
            const action = apiGetOneClientOfferDownload(id, idList, `${name}.zip`);
            yield wrapDispatch(dispatch, action);
        }));
    }), [id, dispatch, name, offers]);
    const [onClick, downloading] = usePromiseDoingCallback(rawOnClick, unmountRef);
    return {
        downloading,
        onClickDownload: onClick,
    };
};
export const rfpInterviewDownloadUseCase = {
    useDownload,
};
export default rfpInterviewDownloadUseCase;
